module.exports = __webpack_public_path__ + "assets/img/teacher (17).7cde9f5e.png";